import React, { useEffect, useState } from 'react';

import { ICompany } from 'interfaces/companies';
import { useDispatch, useSelector } from 'store';
import { fetchCompanies, setActiveCompany, selectActiveCompany, selectCompanies } from 'store/companiesReducer';
import { formatPhoneNumber } from 'utils/formatter';
import Card from 'components/Card';
import classes from './companies.module.scss';

const Companies: React.FC = () => {
	const dispatch = useDispatch();
	const companies = useSelector(selectCompanies);
	const activeCompany = useSelector(selectActiveCompany);
	const [isLoading, setIsLoading] = useState(true);

	const getCompanies = async (): Promise<void> => {
		setIsLoading(true);
		try {
			const newCompanies = await dispatch(fetchCompanies()).unwrap();
			const newActiveCompanyData = newCompanies.find((company) => company.id === activeCompany?.id) || null;
			dispatch(setActiveCompany(newActiveCompanyData));
		} catch (err) {
			console.log(err);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getCompanies();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const renderCompanies = ({ id, name, tin, kpp, ogrn, country, region, address, phone, RtkLabUserId }: ICompany): JSX.Element => {
		const companyInfo: { [key: string]: string | number } = {
			'Лицевой счет': RtkLabUserId,
			'ИНН': tin,
			'КПП': kpp || '',
			'ОГРН': ogrn,
			'Страна': country,
			'Регион': region,
			'Адрес регистрации': address,
			'Номер телефона': phone ? formatPhoneNumber(phone) : '--',
		};
		return (
			<React.Fragment key={id}>
				<div className={classes.title}>{name}</div>
				<Card className={classes.company} isLoading={isLoading}>
					<div className={classes.companyInfo}>
						{Object.keys(companyInfo).map((infoTitle) => (
							<div className={classes.info} key={infoTitle}>
								<div className={classes.infoTitle}>{infoTitle}</div>
								<div className={classes.infoText}>{companyInfo[infoTitle] || '--'}</div>
							</div>
						))}
					</div>
				</Card>
			</React.Fragment>
		);
	};

	return (
		<div className={classes.companies}>
			{/* TODO: add skeleton loader */}
			{companies.map(renderCompanies)}
		</div>
	);
};

export default Companies;
